import type {ReactElement} from 'react';
import React, {useEffect, useRef, useState} from 'react';
import {loadDesignGallery} from '@Libraries/poster-library';
import type {GalleryPageURI} from '@Components/design-gallery/design-gallery.types';
import {GalleryThemeURI} from '@Components/design-gallery/design-gallery.types';
import styles from './design-gallery.module.scss';

interface DesignGalleryProps {
  onDesignSelected: (designHashedId: string) => void;
  disableCreateFromScratchCTA?: boolean;
  height?: string;
  startingPageURI?: GalleryPageURI;
}

export function DesignGallery({
  onDesignSelected,
  disableCreateFromScratchCTA = true,
  height = '80vh',
  startingPageURI = GalleryThemeURI.DEFAULT,
}: DesignGalleryProps): ReactElement | null {
  const [isGalleryLoaded, setIsGalleryLoaded] = useState(false);
  const parentRef = useRef<HTMLDivElement>(null);
  const galleryDesignClickedEvent = 'gallery-design-clicked';
  const loadDesignGalleryInElement = async (): Promise<void> => {
    await loadDesignGallery('.js-design-gallery-embedded-content', '.js-embedded-gallery-container', disableCreateFromScratchCTA, startingPageURI);
  };

  const onGalleryDesignClicked = (event: CustomEvent): void => {
    onDesignSelected(event.detail.id as string);
  };

  useEffect(() => {
    if (!isGalleryLoaded) {
      void loadDesignGalleryInElement().then((): void => {
        setIsGalleryLoaded(true);
      });
    }

    window.addEventListener(galleryDesignClickedEvent, onGalleryDesignClicked as EventListener);

    return () => {
      window.removeEventListener(galleryDesignClickedEvent, onGalleryDesignClicked as EventListener);
    };
  }, []);

  return (
    <div ref={parentRef}>
      <div className={`js-embedded-gallery-container gallery-content-container ${styles.galleryContentContainer} ${styles.galleryScrollStyles}`} style={{height}}>
        <div className={`content  ${styles.mainContentContainer}`}>
          <div className={`js-loader-container ${styles.loaderBackground}`} />
          <div className={`js-design-gallery-embedded-content ${styles.galleryContent}`} />
        </div>
      </div>
    </div>
  );
}
